import Image from "next/image";
import { memo } from "react";

import styles from "./AvatarIcon.module.scss";

type AvatarIconProps = {
  avatar?: string | null;
  background?: string | null;
};

const AvatarIcon = ({ avatar, background }: AvatarIconProps) => {
  return (
    <div className={styles.avatarImageWrap}>
      <Image
        className={styles.userImage}
        src={avatar || "/images/init/InitProfileAvatar.png"}
        alt="アバター"
        width={600}
        height={800}
      />

      <Image
        className={styles.userBackGround}
        src={background || "/images/init/InitBackground_ミニマム部屋.png"}
        alt="背景"
        width={600}
        height={800}
      />
    </div>
  );
};

export const AvatarIconMemo = memo(AvatarIcon);
